// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"daf5063b","320":"27ddf828","566":"206902c7","984":"203d0d65"}[chunkId] + ".chunk.css";
};